// extracted by mini-css-extract-plugin
export var hidden = "_6v-1";
export var visible = "_6v-0";